import VerifyOutItemAdjustment from "../../../../components/@documents/item_adjustments/VerifyOutItemAdjustment";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemAdjustmentVerifyOutPage() {

    return (
        <VerifyOutItemAdjustment 
            routeType={routeTypes.admin}
        />
    )
}